import React, { useRef, useEffect } from 'react';
import { Accordion } from 'cd-eft/components/common/Accordion';
import { observer } from 'mobx-react';
import { Table, Form, FormGroup, Label, Col, Input } from 'reactstrap';
import { AdditionalProjectDetailsVM } from './AdditionalProjectDetailsVM';
import './AdditionalProjectDetails.scss';

const AdditionalProjectDetailsComponent = (props) => {
  const vm = useRef(new AdditionalProjectDetailsVM(props)).current;
  useEffect(() => {
    vm.getAdditionalProjectDetails(props.projectId);
  }, [props.projectId]);

  return (
    <>
      {vm.projectDetails && (
        <div className="contanier">
          <Accordion className="p-0 accordion-wrapper" headers={['Additional Project Details']} >
            <div className="project-detail-wrapper">
              {!vm.elementsVisible && (
                <>
                  <Table borderless>
                    <tbody>
                      <tr>
                        <th scope="row">Practice:</th>
                        <td>
                          {vm.projectDetails.practice === null || vm.projectDetails.practice === '' ? (
                            <div> No Practice </div>
                          ) : (
                            <div> {vm.projectDetails.practice} </div>
                          )}
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Location:</th>
                        <td>
                          {vm.projectDetails.location === null || vm.projectDetails.location === '' ? (
                            <div> No Location </div>
                          ) : (
                            <div> {vm.projectDetails.location} </div>
                          )}
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Description:</th>
                        <td>
                          {vm.projectDetails.description === null || vm.projectDetails.description === '' ? (
                            <div> No Description </div>
                          ) : (
                            <div> {vm.projectDetails.description} </div>
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                  <div className={'text-right btn-edit'}>
                    <button className="usa-button m-0" onClick={vm.handleEdit}>
                      Edit
                    </button>
                  </div>
                </>
              )}

              {/* Edit Project Details Form */}
              {vm.elementsVisible && (
                <div>
                  <Form fluid={+true}>
                    <FormGroup row>
                      <Label for="practice" sm={1}>
                        Practice:
                      </Label>
                      <Col>
                        <Input
                          name="practice"
                          defaultValue={vm.projectDetails.practice}
                          placeholder="add practice"
                          type="text"
                          onChange={vm.handleInputChange}
                        />
                      </Col>
                    </FormGroup>
                    <FormGroup row>
                      <Label for="location" sm={1}>
                        Location:
                      </Label>
                      <Col>
                        <Input
                          name="location"
                          defaultValue={vm.projectDetails.location}
                          placeholder="add location"
                          type="text"
                          onChange={vm.handleInputChange}
                        />
                      </Col>
                    </FormGroup>
                    <FormGroup row>
                      <Label for="location" sm={1}>
                        Description:
                      </Label>
                      <Col>
                        <Input
                          name="description"
                          defaultValue={vm.projectDetails.description}
                          placeholder="add description"
                          type="text"
                          onChange={vm.handleInputChange}
                        />
                      </Col>
                    </FormGroup>
                  </Form>
                  <div className={'d-flex justify-content-end btn-edit'}>
                    <button className="usa-button usa-button--outline" onClick={vm.cancelEdit}>
                      Close
                    </button>
                    <button className="usa-button" onClick={vm.editAdditionalProjectDetails}>
                      Save
                    </button>
                  </div>
                </div>
              )}
            </div>
          </Accordion>
        </div>
      )}
    </>
  );
};
export const AdditionalProjectDetails = observer(AdditionalProjectDetailsComponent);
